import React from 'react';
import cx from 'classnames';
import { Row, Cell } from 'experium-react-sticky-table';
import { drop } from 'ramda';
import { withRouter } from 'react-router';
import Translate from 'react-translate-component';

import { DEFAULT_COLUMN_WIDTH } from 'constants/defaultColumns';
import { mapIndexed } from 'utils/ramdaAdditions';

const TableLabel = ({ children = null, className,  columns = [] }) => (
    <Row key="label" className={cx('table-row-group', className)}>
        <Cell key={0}>
            <div className="table-label-cell">
                <span className="table-row-group-title">{ children }</span>
            </div>
        </Cell>
        { mapIndexed((column, index) => (
            <Cell key={index + 1}>
                <div style={{width: column.width || DEFAULT_COLUMN_WIDTH}}></div>
            </Cell>
        ), drop(1, columns)) }
    </Row>
);

export default TableLabel;

export const TableLabelWithRoute = withRouter(({ match: { params: { status } }, ...props }) => (
    <TableLabel { ...props } >
        <Translate content={'filterStatus.approvals.' + status} />
    </TableLabel>
));
